module.exports = __webpack_public_path__ + "media/images/services/thumbnail/img_photo-da894738eb85b0831cc7df125074939f.jpg";